import { NotificationStatus } from '@aibees/shared/features/notifications';
import { useBrowseNotificationsApi } from '@aibees/shared/features/notifications/api/use-browse-notifications-api';
import { useNotificationStore } from '@aibees/shared/features/notifications/store';
import { useRef } from 'react';
import { getNotificationConfig } from './use-get-notification-config';

interface UseInfiniteNotificationsResult {
  loadingMore: boolean;
  isLoadingInitial: boolean;
}

export const useInfiniteNotifications = (): UseInfiniteNotificationsResult => {
  const setNotifications = useNotificationStore.useSetNotifications();
  const setLoadingMore = useNotificationStore.useSetLoadingMore();
  const setHasMore = useNotificationStore.useSetHasMore();
  const setIsLoadingInitial = useNotificationStore.useSetIsLoadingInitial();
  const setContainerRef = useNotificationStore.useSetContainerRef();
  const page = useNotificationStore.usePage();
  const loadingMore = useNotificationStore.useLoadingMore();
  const setNotificationConfig = useNotificationStore.useSetNotificationConfig();
  const containerRef = useRef<HTMLDivElement>(null);
  // Set the container ref in the store when it's available
  if (containerRef.current) {
    setContainerRef(containerRef);
  }
  // Set the notification config function in the store
  setNotificationConfig(getNotificationConfig);

  const api = useBrowseNotificationsApi(
    {
      page,
      size: 25,
      statuses: NotificationStatus.ALL,
    },
    {
      onSuccess(data) {
        setLoadingMore(false);
        setIsLoadingInitial(false);

        setNotifications((prevNotifications) => {
          if (page === 0) {
            return data.content ?? [];
          }
          return [...prevNotifications, ...(data.content ?? [])];
        });

        setHasMore(!data.last);
      },
      onError() {
        setLoadingMore(false);
        setIsLoadingInitial(false);
      },
    }
  );

  return {
    loadingMore,
    isLoadingInitial: api.isLoading && page === 0,
  };
};
